import React from 'react';
import LazyLoad from 'react-lazyload';
import { Link } from 'react-router-dom'; 
  
const Footer = () => { 
  const currentYear = new Date().getFullYear(); 
    return (
        <>
            <div className="footer padded-sec">
                 <div className='container-fluid'>
                  <div className='row'>
                    <div className='col-lg-6 col-12'>
                      <div className='ftr-logo'>
                      <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LFSGV/public/Images/ftr-logo.png" alt="Little Flower School" /></LazyLoad>
                        <ul>
                          <li><Link to="https://www.facebook.com/littleflowerschoolgkp" target="_blank"><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LFSGV/public/Images/facebook.png" alt="Little Flower School" /></LazyLoad></Link></li>
                          <li><Link to="https://www.youtube.com/channel/UCucCBCEgweiPSBdphRi0GPw" target="_blank"><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LFSGV/public/Images/youtube.png" alt="Little Flower School" /></LazyLoad></Link></li>
                          <li><Link to="https://www.instagram.com/lfsgkp/" target="_blank"><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LFSGV/public/Images/insta.png" alt="Little Flower School" /></LazyLoad></Link></li>
                        </ul>
                      </div>
                    </div>                    
                    <div className='col-lg-6 col-12'>
                      <div className="mobile-app">
                        <div>
                          <h6>Download Mobile App  </h6>
                          <p>   CampusCare 10x mobile app for parents is a tool that serves as a single point of reference for parents. The app centralises all the school-parent interaction and lets parents stay updated with their ward's day-to-day activities. Parents can receive assignments, homework, and circulars, keep track of their child's attendance, do online fee payment, view report cards.</p>
                          <div className='mobile-link'>
                            <Link to="https://apps.apple.com/in/app/campuscare-10x/id1611283814" target='_blank'><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LFSGV/public/Images/app-store.png" alt="Little Flower School" /></LazyLoad></Link>
                            <Link to="https://play.google.com/store/apps/details?id=com.entab.learninglab&hl=en-IN" target='_blank'><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LFSGV/public/Images/playstore.png" alt="Little Flower School" /></LazyLoad></Link>
                          </div>
                          <p className='code'>Use School Code : LFSGUP</p>
                        </div>
                        <div>
                         <LazyLoad> <img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LFSGV/public/Images/mobile.png' alt="Little Flower School" /></LazyLoad>
                        </div>
                      </div>
                    </div>
                  </div>
                 </div>
            </div>
            <div className='copyright'>
            ©️Copyright 2020 - {currentYear} LFS, GKP All Rights Reserved | Created by Entab Infotech : CampusCare®️  
            </div>
        </>
    );
}

export default Footer;
